
      import LocationInformation from './location-information.vue'
      import type { App, Plugin } from 'vue'

      export const LocationInformationPlugin: Plugin = {
        install(app: App) {
          app.component('LocationInformation', LocationInformation)
        },
      }
      export { LocationInformation }
      